import { connect } from 'react-redux';
import SettingsBar from './SettingsBar';
import { actions as optionsActions } from '../actions/options';
import { openDataSettingsDialog } from '../actions/dataSettingsDialog';
import {
  getCompare,
  getSafeMetric,
  getTimespan,
  getSafeCrimeType,
} from '../selectors/options';
import { getAvailableCompare } from '../selectors/intervals';
import { getCrimeTypeText } from '../selectors/crimes';
import { getDataSettingsDialogOpened } from '../selectors/dataSettingsDialog';
import { isCensusView } from '../selectors/router';

export default connect(
  state => ({
    crimeType: getSafeCrimeType(state),
    crimeTypeText: getCrimeTypeText(state),
    metric: getSafeMetric(state),
    timespan: getTimespan(state),
    compare: getCompare(state),
    availableCompare: getAvailableCompare(state),
    isDataSettingsDialogOpened: getDataSettingsDialogOpened(state),
    censusView: isCensusView(state),
  }),
  {
    setCrimeType: optionsActions.setCrimeType,
    setCompare: optionsActions.setCompare,
    setMetric: optionsActions.setMetric,
    setTimespan: optionsActions.setTimespan,
    openDataSettingsDialog,
  },
)(SettingsBar);



// WEBPACK FOOTER //
// ./src/components/SettingsBarContainer.jsx